const Show = ({ when, children }) => {
	if (when) return children;
	else return null;
};

export default Show;
